import { render, staticRenderFns } from "./organizationManage.vue?vue&type=template&id=23d1dcfe&scoped=true&"
import script from "./organizationManage.vue?vue&type=script&lang=js&"
export * from "./organizationManage.vue?vue&type=script&lang=js&"
import style0 from "./organizationManage.vue?vue&type=style&index=0&id=23d1dcfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1dcfe",
  null
  
)

export default component.exports